/**
 * The release stage, shown beside the wordmark while MeetFolks is pre-release.
 *
 * One value for every place the stage appears. The React screens read it here; the
 * static header in `index.html` and the public pages (`home`, `privacy`, `terms`) carry
 * it as plain markup, and `stage-badge.test.ts` fails if any of them disagrees with it.
 * When the product leaves alpha, set this to `null`, delete the badge markup the test
 * then points at, and rewrite the alpha paragraph in the Terms (§7).
 *
 * Deliberately not in the page titles or meta descriptions: it is a label for the
 * person using the app, not for search results.
 */
export const RELEASE_STAGE: string | null = "Alpha";

/** The badge, styled by `.stage` in `app.css` (shared with the static pages). */
export function StageBadge({ className }: { className?: string }) {
  if (RELEASE_STAGE === null) return null;
  return <span className={className ? `stage ${className}` : "stage"}>{RELEASE_STAGE}</span>;
}
